import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export function useBreakpoint() {
  const theme = useTheme();

  const xs = useMediaQuery(theme.breakpoints.down("sm"));
  const sm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const md = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const lg = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));
  const smallScreen = xs || sm;

  let active = "xs";
  if (sm) active = "sm";
  if (md) active = "md";
  if (lg) active = "lg";
  if (xl) active = "xl";

  return { xs, sm, md, lg, xl, smallScreen, active };
}
